// extracted by mini-css-extract-plugin
export default {"button":"Zwrm7aDb","icon":"lGtsxpv1","menu":"Pc0Y7YGI","contextMenu":"kuj1PIIl","menuBubble":"UhvMK8mg","item":"AZjbQROQ","menuItemDescription":"XbyfBxfu"};